import AjaxModal from "./ajax_modal";
import { initializeModals, displayToast, sendAppsignalError } from "../modules/utils";

export default class InstantModal extends AjaxModal {
  fetchModal() {
    this.cookie = this.trigger.dataset.cookie;

    if (!this.checkCookie()) {
      // If we already have a cookie, we don't need to fetch the modal
      return;
    }

    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.text();
        }

        throw new Error("Something went wrong");
      })
      .then((html) => {
        this.removeExistingModals();
        this.initializeModal(html);

        window.Beyuna.initClasses(this.modalWrapperElement); // load all custom js
        initializeModals(this.modalWrapperElement);

        const leaveButton = this.modalElement.querySelector(".js-leave-modal");

        if (leaveButton) {
          leaveButton.addEventListener("click", (e) => {
            e.preventDefault();

            this.setCookie();
            window.location.href = leaveButton.href;
          });
        }

        this.modalElement.addEventListener("hidden.bs.modal", () => {
          this.disposeModal();
          this.setCookie();
        });
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.trigger.dataset.errorMessage);
        sendAppsignalError(e, "InstantModal", {
          response: this.response,
        });
      });
  }

  checkCookie() {
    if (!this.cookie) return true; // Incase we let the back-end handle if the modal should be shown

    const cookie = document.cookie.split(";").find((cookie) => cookie.includes(this.cookie));

    if (cookie) {
      const cookieValue = JSON.parse(cookie.split("=")[1]);
      if (cookieValue === "acknowledged") {
        return false;
      }
    }

    return true;
  }

  setCookie() {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + 3 * 60 * 60 * 1000); // 3 hours from now

    const cookie = `${this.cookie}="acknowledged"; expires=${expirationDate.toUTCString()}; samesite=strict; domain=${window.location.hostname}; path=/`;

    document.cookie = cookie;
  }
}
